import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from '@mui/styles';

import { useStore } from 'webPosApp/hooks';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => {
    return {
        root: {
            padding: '0 60px',
            height: '100%',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
        },
        
        body: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop:'5vh',
        },
        
        title: {
            fontSize: '3.5rem',
            textAlign: 'center',
            maxWidth: '700px',
        },
    };
});


export const ConfirmationFrame: React.FC = () => {
    const Store = useStore();
    const classes = useStyles();
    const { t } = useTranslation();

    const { confirmation } = Store;

    useEffect(() => {
        confirmation.getConfirmDetails()
        .then((data) => {
            confirmation.confirmPayment(data).then(() => {
                confirmation.confirmSuccess();        
            })
            .catch(() => {
                confirmation.confirmFailed();  
            })
        })
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className={classes.root}>
                <div className={classes.body}>
                    <Typography variant='h2' className={classes.title}>
                        {t('Thank You For Your Payment!')}
                    </Typography> 
                </div>
            </div>
        </>
    );
};